module.exports = {
          srcSet: __webpack_public_path__ + "1ef34c5eb8567d5b94b831f0d9249e36-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "1ef34c5eb8567d5b94b831f0d9249e36-90.png",width: 90,height: 69}],
          src: __webpack_public_path__ + "1ef34c5eb8567d5b94b831f0d9249e36-90.png",
          toString:function(){return __webpack_public_path__ + "1ef34c5eb8567d5b94b831f0d9249e36-90.png"},
          
          width: 90,
          height: 69
        }